import React from "react";

/** Figma chart-no-axes-combined — outer 40×40, leaf inset 12.5% / 8.33% (node 2181:7670) */
const ChartNoAxesCombinedIcon = ({
    className,
    ...rest
}: React.SVGProps<SVGSVGElement>) => {
    return (
        <span className="relative inline-block size-10 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[12.5%_8.33%]">
                <svg
                    className={className ?? "block size-full"}
                    viewBox="0 0 35.3333 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...rest}
                >
                    <path
                        d="M17.6667 22.6667V31M24.3333 19.3333V31M31 12.6667V31M34.3333 1L19.9233 15.41C19.8459 15.4876 19.754 15.5492 19.6527 15.5912C19.5515 15.6332 19.4429 15.6548 19.3333 15.6548C19.2237 15.6548 19.1152 15.6332 19.0139 15.5912C18.9127 15.5492 18.8207 15.4876 18.7433 15.41L13.2567 9.92333C13.1004 9.76711 12.8885 9.67934 12.6675 9.67934C12.4465 9.67934 12.2346 9.76711 12.0783 9.92333L1 21M4.33333 26V31M11 19.3333V31"
                        stroke="#F15D2A"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    );
};

export default ChartNoAxesCombinedIcon;
